__turbopack_context__.v({
  "arrow": "clientMobile-module-scss-module__zJKWoW__arrow",
  "pulse": "clientMobile-module-scss-module__zJKWoW__pulse",
  "selectEntitiesButton": "clientMobile-module-scss-module__zJKWoW__selectEntitiesButton",
  "selectEntitiesButtonContainer": "clientMobile-module-scss-module__zJKWoW__selectEntitiesButtonContainer",
  "selectEntitiesTitleButton": "clientMobile-module-scss-module__zJKWoW__selectEntitiesTitleButton",
  "skeleton": "clientMobile-module-scss-module__zJKWoW__skeleton",
  "user": "clientMobile-module-scss-module__zJKWoW__user",
  "user-icon": "clientMobile-module-scss-module__zJKWoW__user-icon",
  "user-icon-hide": "clientMobile-module-scss-module__zJKWoW__user-icon-hide",
  "user-name": "clientMobile-module-scss-module__zJKWoW__user-name",
  "user-name-skeleton": "clientMobile-module-scss-module__zJKWoW__user-name-skeleton",
  "user-select": "clientMobile-module-scss-module__zJKWoW__user-select",
  "user-seperator": "clientMobile-module-scss-module__zJKWoW__user-seperator",
});
